import { render, staticRenderFns } from "./PageBalance.vue?vue&type=template&id=701b4564"
import script from "./PageBalance.vue?vue&type=script&lang=js"
export * from "./PageBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports